import script from "./BillToPayForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillToPayForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__